"use strict";
/*
 * CODEX-GENERATED: the contents of this file were fully constructed by a Codex agent and not a human.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pingBackend = exports.STARTUP_PING_TIMEOUT_MS = void 0;
exports.STARTUP_PING_TIMEOUT_MS = 10000;
function pingBackend(apiBaseUrl_1) {
    return __awaiter(this, arguments, void 0, function* (apiBaseUrl, timeoutMs = exports.STARTUP_PING_TIMEOUT_MS) {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), timeoutMs);
        try {
            const response = yield fetch(`${apiBaseUrl}/ping`, {
                signal: controller.signal,
            });
            return response.ok;
        }
        finally {
            window.clearTimeout(timeout);
        }
    });
}
exports.pingBackend = pingBackend;
